import * as React from 'react'
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

import { Label } from '@common/components/Label';
import { Ellipsis } from '@common/components/Ellipsis';
import Tree from '@common/components/Tree';
import { Flex } from '@common/components/Flex';
import { getTestAttributes } from '@common/utils/tests';
import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';

import { FoldersProps } from './folders.types';
import { useController } from './folders.controller';

import './folders.styles.scss';

export const Folders: React.FC<FoldersProps> = (props) => {
  const {
    className,
    list,
    selectedFolderId,
    onChange,
    totalItemsCount,
    onNewFolderClick,
    onRenameFolderClick,
    onDeleteFolderClick,
    getFoldersActions,
    getId,
    userPermissions,
  } = props;

  const { selectedFolderName, labels } = useController(props);

  const handleNewFolderClick = React.useCallback(() => {
    onNewFolderClick();
  }, [onNewFolderClick]);

  const handleChange = React.useCallback((id: FolderPrimaryListDto['id']) => {
    if (selectedFolderId !== id) {
      onChange(id);
    }
  }, [selectedFolderId, onChange]);

  return (
    <div className={cx('Folders', className)}>
      <Flex className="Folders__header" justify="space-between">
        <div className="Folders__header__label__wrapper">
          <Flex>
            <Label className="Folders__header__label" text={I18n.t('Folder')} />
            {userPermissions.canAddFolder && (
                <button
                    {...getTestAttributes({ id: getId.addFolder })}
                    type="button"
                    className="Folders__header__create-folder-btn btn btn-light"
                    onClick={handleNewFolderClick}
                >
                  <Flex alignItems="center" justify="center">
                    <i
                        className="fa fa-plus text-primary Folders__header__create-folder-icon"
                        aria-hidden="true"
                    />
                  </Flex>
                </button>
            )}
          </Flex>
        </div>
        <Ellipsis
          maxWidth="98%"
          className="Folders__header__count"
          text={list.length
            ? selectedFolderName
              ? `${totalItemsCount} ${I18n.t('item')}${totalItemsCount === 1 ? '' : 's'} ${I18n.t('in')} ${selectedFolderName}`
              : `${totalItemsCount} ${I18n.t('items found')}`
            : ''
          }
        />
      </Flex>
      {Boolean(list.length) && (
        <Tree
          getId={{
            folder: getId.treeFolder,
            collapseIcon: getId.treeCollapseIcon,
            actionBtn: getId.treeActionBtn,
            promptCancelBtn: () => 'btn-bootstrap-message-cancel',
            promptConfirmBtn: () => 'btn-bootstrap-message-ok',
          }}
          collapseAfterLevel={0}
          className="Folders__list"
          items={list}
          value={selectedFolderId}
          onChange={handleChange}
          getActions={getFoldersActions}
          onRename={onRenameFolderClick}
          onDelete={onDeleteFolderClick}
          labels={labels}
        />
      )}
    </div>
  );
};